import BuyCreditPointsDialog from './BuyCreditPointsDialog';

export default BuyCreditPointsDialog;
